import React, {useEffect, useRef} from "react";

/**
 * @Author: Karen Yunuen Pozos Arias
 * @JobTitle : Full Stack Developer - IBL
 * @Email : kpozos@ibl.mx
 *
 * @Description Container Tab/Step with dynamic content
 * @param String index: Identifier for the tab/step position (required)
 * @param JSX.Element children: Text or JSX element (required)
 * @param Integer activeStep: UseState for current tab (optional)
 * @param {Boolean} normalHeight - If true, sets a fixed height (50%) for the tab content (optional)
 * @param {String} classes - Extra custom class names to apply to the container (optional)
 * @returns {JSX.Element}
 */
const StepTab = (props) => {
    const { index, children, activeStep, normalHeight = false, classes=""} = props;
    const elementRef = useRef(null);

    useEffect(() => {
        if(children) calculateTop();
    }, [activeStep, children]);

    const calculateTop = () =>{
        if (elementRef.current) {
            const rect = elementRef.current.getBoundingClientRect();
            const distanceTop = rect.top + 0;
            elementRef.current.style.setProperty('--stepper-top', `${distanceTop}px`);
        }
    }

    return <>
        <div ref={elementRef} className={`${activeStep === index ? "d-block" : "d-none"} justify-content-right ${normalHeight ? "h-50" : "custom-swipeable custom-scrollbar"} mt-1 pt-2 ${classes}`}>
            {children}
        </div>

    </>
}

export default StepTab;
